import React, { useEffect, useState } from 'react';
import { Card, CardColumns, CardImg, Col, Row } from 'reactstrap';
import { authHeader } from '../../helpers/auth-header';

const OrganisationImages = props => {
    const [portals, setportals] = useState([]);

    useEffect(() => {
        fetch(`./Organisations/GetSystemOrganisations`, {
            method: 'GET',
            headers: authHeader(false, true)
        })
            .then(response => response.json())
            .then(data => {
                setportals(data);
            })
            .catch(err => {
                console.log(err);
            })

        return () => {
            setportals([]);
        }
    }, [])

    if (portals) {
        return (
            <>
                <h2 className="u-component-spacing u-branded-underline">
                    Available In-tend Portals
                </h2>
                <Row className="u-component-spacing--2x">
                    <Col>
                        <CardColumns className="card-columns-logos">
                            {
                                portals.map((portal, i) => {
                                    return (
                                        <Card className="" key={i} style={{ width: "fit-content", margin: "1rem 2rem" }}>
                                            <CardImg className="img-fluid" style={{ maxHeight: "5rem", width: "auto" }} src={portal.logoImage ? portal.logoImage : 'Logos/Organisations/no-image.png'} alt={portal.entityName} title={portal.entityName} />
                                        </Card>
                                    );
                                })
                            }
                        </CardColumns>
                    </Col>
                </Row>
            </>
        );
    } else {
        return null;
    }
}

export default OrganisationImages;